'use client';
import React from 'react';
import { Package, ShieldCheck, AlertTriangle, Wrench, FileText, HardDrive } from 'lucide-react';
import Icon from '@/components/ui/AppIcon';


const kpis = [
  {
    id: 'kpi-products',
    label: 'Products Registered',
    value: '24',
    change: '+3 this month',
    trend: 'up',
    icon: Package,
    color: 'text-primary',
    bg: 'bg-primary/8',
    span: 'col-span-1',
    hero: false,
  },
  {
    id: 'kpi-active-warranties',
    label: 'Active Warranties',
    value: '19',
    change: '79% of products covered',
    trend: 'up',
    icon: ShieldCheck,
    color: 'text-success',
    bg: 'bg-success/8',
    span: 'col-span-1',
    hero: false,
  },
  {
    id: 'kpi-expiring',
    label: 'Expiring Within 30 Days',
    value: '4',
    change: '↑ 2 since last week',
    trend: 'down',
    icon: AlertTriangle,
    color: 'text-warning',
    bg: 'bg-warning/8',
    span: 'col-span-1',
    hero: false,
    alert: true,
  },
  {
    id: 'kpi-service',
    label: 'Open Service Requests',
    value: '3',
    change: '1 overdue SLA',
    trend: 'neutral',
    icon: Wrench,
    color: 'text-accent',
    bg: 'bg-accent/8',
    span: 'col-span-1',
    hero: false,
  },
  {
    id: 'kpi-invoices',
    label: 'Invoices Stored',
    value: '47',
    change: '+5 this week',
    trend: 'up',
    icon: FileText,
    color: 'text-info',
    bg: 'bg-info/8',
    span: 'col-span-1',
    hero: false,
  },
  {
    id: 'kpi-storage',
    label: 'Storage Used',
    value: '68%',
    change: '3.4 GB of 5 GB',
    trend: 'neutral',
    icon: HardDrive,
    color: 'text-muted-foreground',
    bg: 'bg-muted',
    span: 'col-span-1',
    hero: false,
  },
];

export default function DashboardKPIGrid() {
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-6 2xl:grid-cols-6 gap-4">
      {kpis?.map((kpi) => {
        const Icon = kpi?.icon;
        return (
          <div
            key={kpi?.id}
            className={`bg-card rounded-xl p-5 border shadow-card hover:shadow-card-hover transition-all duration-200 ${kpi?.alert ? 'border-warning/40 bg-warning/5' : 'border-border'}`}
          >
            <div className="flex items-start justify-between mb-3">
              <div className={`w-9 h-9 rounded-lg ${kpi?.bg} flex items-center justify-center flex-shrink-0`}>
                <Icon size={18} className={kpi?.color} />
              </div>
              {kpi?.alert && (
                <span className="text-[10px] font-600 bg-warning/15 text-warning px-1.5 py-0.5 rounded-full">Alert</span>
              )}
            </div>
            <p className="text-[11px] font-500 uppercase tracking-wider text-muted-foreground mb-1">{kpi?.label}</p>
            <p className={`text-2xl font-700 tabular-nums text-foreground mb-1`}>{kpi?.value}</p>
            <p className={`text-xs font-400 ${kpi?.trend === 'up' ? 'text-success' : kpi?.trend === 'down' ? 'text-danger' : 'text-muted-foreground'}`}>
              {kpi?.change}
            </p>
          </div>
        );
      })}
    </div>
  );
}